import { render, staticRenderFns } from "./PengalamanInvestasi.vue?vue&type=template&id=461293ae&scoped=true&"
import script from "./PengalamanInvestasi.vue?vue&type=script&lang=js&"
export * from "./PengalamanInvestasi.vue?vue&type=script&lang=js&"
import style0 from "./PengalamanInvestasi.vue?vue&type=style&index=0&id=461293ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461293ae",
  null
  
)

export default component.exports